import VSCode from "../../../../docs/_images/vscodehello.png";
import JaguarVideo from "../../../../docs/_images/146210503-24811800-bb26-4244-817d-6422b20e6786.png";
import * as React from 'react';
export default {
  VSCode,
  JaguarVideo,
  React
};